import { Text, Box } from '@simplywallst/ui-core';

/**
 * @todo: Convert to tailwind
 */
export const EmptyTableBody = () => {
  return (
    <tbody>
      <tr>
        <td colSpan={4}>
          <Box backgroundColor="phantom" padding="x2">
            <Text typography="xSmall" color="textSubtle" textAlign="center">
              You currently have no holdings that pay dividends
            </Text>
          </Box>
        </td>
      </tr>
    </tbody>
  );
};
